<template>
    <div class="rank_wrap">
        <div class="t">
            <div class="title">排行榜</div>
            <div class="more" @click="moreClick">更多>></div>
        </div>
        <div class="rankList">
            <div class="rank_item" v-for="(item,index) in dataList" :key="index" @mouseover="showActive(index,dataList)" @click="goDet(item)">
                <div v-show="item.active||(item.active===undefined&&index==0)" class="under_img"><img :src="item.eventlogo" alt=""></div>
                <div class="topRank" v-bind:class="{red:index===0,yellow:index===1,green:index===2}" :style="item.activeBg">
                    <span class="index">{{index+1}}</span>
                    <span class="desp">{{item.title}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "rankList",
        props:['dataList'],
        data(){
            return{
                activeBg:'', //鼠标移动背景色
            }
        },
        methods:{
            showActive(index,item){
                item.forEach((list,ind)=>{
                    if(index == ind){
                        this.$set(list,'active',true);
                        this.$set(list,'activeBg','background-color: #f8f7f7');
                    }
                    else{
                        this.$set(list,'active',false);
                        this.$set(list,'activeBg','');
                    }
                })
            },
            //更多
            moreClick(){
                this.$router.push({name: 'HdSearch'})
            },
            //跳转至详情
            goDet(row){
                const { href } = this.$router.resolve({
                    name: "HdDetails",
                    query: {
                        eventid: row.eventid
                    }
                })
                window.open(href, '_blank');
            },
        }
    }
</script>

<style lang="scss">
    .rank_wrap{
        .t{
            .title{
                border-left: 0!important;
            }
        }
        .rankList{
            height:auto;
            border:1px solid rgba(229,229,229,1);
            padding: 18px 0;
            margin-top: 30px;
            .rank_item{
                margin-top: 7px;
                .topRank{
                    display: flex;
                    align-items: center;
                    padding: 6px 18px;
                    margin-left: 1px;
                    .index{
                        width:20px;
                        height:20px;
                        line-height: 20px;
                        text-align: center;
                        background:rgba(229,229,229,1);
                        font-size: 16px;
                        color: #999999;
                        display: inline-block;
                        margin-right: 8px;
                    }
                    .desp{
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                        display: inline-block;
                        width: 220px;
                    }
                }
                .red{
                    color: rgba(245,108,108,1);
                    .index{
                        background:rgba(245,108,108,1);
                        color: #fff;
                    }
                }
                .yellow{
                    color: rgba(255,169,4,1);
                    .index{
                        background:rgba(255,169,4,1);
                        color: #fff;
                    }
                }
                .green{
                    color: rgba(10,191,83,1);
                    .index{
                        background:rgba(10,191,83,1);
                        color: #fff;
                    }
                }
                .under_img{
                    margin: 10px 0;
                    padding: 0 18px;
                    /*display: none;*/
                    img{
                        width: 250px;
                        height: 145px;
                    }
                }
            }
            .rank_item:first-child{
                margin-top: 0;
            }
            .rank_item:first-child .under_img{
                margin-top: 0;
            }
            .rank_item:hover{
                cursor: pointer;
            }
            /*.rank_item:hover .topRank{*/
                /*background: #f8f7f7;*/
            /*}*/
            /*.rank_item:hover .under_img{*/
                /*display: block;*/
            /*}*/
        }
    }
</style>